// extracted by mini-css-extract-plugin
export var fadeIn = "_dw-1";
export var modalContent = "_dw-3";
export var overlay = "_dw-0";
export var popoverContent = "_dw-2";
export var results = "_dw-5";
export var searchInputWrapper = "_dw-4";